<div class="hds-panel-layout"
     style="margin-top: 40px">
  <div class="hds-panel-layout-left z-depth-2 bg-white">
    <app-menu>
    </app-menu>
  </div>
  <div class="hds-panel-layout-main-container auto-height-panel">
    <app-dashboard>
    </app-dashboard>
  </div>
</div>
